import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const scrollPositions = new Map<string, number>();

// Paths that should NOT restore scroll (always scroll to top or handle their own)
const SKIP_PATHS = ["/chat"];

export function useScrollRestoration() {
  const location = useLocation();
  const prevPath = useRef(location.pathname);

  useEffect(() => {
    // Save scroll position of previous page
    if (prevPath.current !== location.pathname) {
      scrollPositions.set(prevPath.current, window.scrollY);
      prevPath.current = location.pathname;
    }

    // Restore scroll position if available
    if (SKIP_PATHS.some((p) => location.pathname.startsWith(p))) return;

    const saved = scrollPositions.get(location.pathname);
    if (saved !== undefined) {
      requestAnimationFrame(() => window.scrollTo(0, saved));
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);
}
